import { AddCommitteeModal } from "./AddCommitteeModal";

export default AddCommitteeModal;
